import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

// Define the initial state of the store
const initialState = {
  token: null,
  contracts: [],
  contractData: [],
  contractDataItem: {},
  expirationDate: 0,
  logoUrl: '',
  contractIsSelected: false,
  selectedContractId: '',
  contractSelectedLink: {},
  userName: '',
  brandName: '',
  brandPrimaryColor: '',
  customerId: ''
}

interface AppStoreState {
  token: string | null
  contracts: any[]
  contractData: any[]
  contractDataItem: any
  expirationDate: number
  logoUrl: string
  contractIsSelected: boolean
  selectedContractId: string
  contractSelectedLink: any
  userName: string
  brandName: string
  brandPrimaryColor: string
  customerId : string
}

interface AppStoreActions {
  setToken: (newToken: string) => void
  setContracts: (newContracts: any[]) => void
  setContractData: (newContractData: any[]) => void
  setContractDataItem: (newContractDataItem: any) => void
  setExpirationDate: (newExpirationDate: number) => void
  setLogoUrl: (newLogoUrl: string) => void
  setContractIsSelected: (newContractIsSelected: boolean) => void
  setSelectedContractId: (newSelectedContractId: string) => void
  setUserName: (newUserName: string) => void
  setBrandName: (newBrandName: string) => void
  setBrandPrimaryColor: (newBrandPrimaryColor: string) => void
  setCustomerId: (newCustomerId: string) => void
  clearSessionStorage: () => void
}

type AppState = {
  token: string | null
  contracts: any[]
  contractData: any[]
  contractDataItem: any
  expirationDate: number
  logoUrl: string
  contractIsSelected: boolean
  selectedContractId: string
  contractSelectedLink: any
  userName: string
  brandName: string
  brandPrimaryColor: string
    customerId : string
  setToken: (t: string) => void
  setContracts: (c: any[]) => void
  setContractData: (d: any[]) => void
  setContractDataItem: (i: any) => void
  setExpirationDate: (e: number) => void
  setLogoUrl: (l: string) => void
  setContractIsSelected: (b: boolean) => void
  setSelectedContractId: (id: string) => void
  setUserName: (u: string) => void
  setBrandName: (b: string) => void
  setBrandPrimaryColor: (c: string) => void
    setCustomerId: (c: string) => void
  clearSessionStorage: () => void
}

const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      token: null,
      contracts: [],
      contractData: [],
      contractDataItem: {},
      expirationDate: 0,
      logoUrl: '',
      contractIsSelected: false,
      selectedContractId: '',
      contractSelectedLink: {},
      userName: '',
      brandName: '',
      brandPrimaryColor: '',
      customerId: '',

      // Methoden 
      setToken: (newToken) => set({ token: newToken }),
      setContracts: (newContracts) => set({ contracts: newContracts }),
      setContractData: (newContractData) => set({ contractData: newContractData }),
      setContractDataItem: (newContractDataItem) => set({ contractDataItem: newContractDataItem }),
      setExpirationDate: (newExpirationDate) => set({ expirationDate: newExpirationDate }),
      setLogoUrl: (newLogoUrl) => set({ logoUrl: newLogoUrl }),
      setContractIsSelected: (newContractIsSelected) => set({ contractIsSelected: newContractIsSelected }),
      setSelectedContractId: (newSelectedContractId) => set({ selectedContractId: newSelectedContractId }),
      setUserName: (newUserName) => set({ userName: newUserName }),
      setBrandName: (newBrandName) => set({ brandName: newBrandName }),
      setBrandPrimaryColor: (newBrandPrimaryColor) => set({ brandPrimaryColor: newBrandPrimaryColor }),
      setCustomerId: (newCustomerId) => set({ customerId: newCustomerId }),
      clearSessionStorage: () => {
        sessionStorage.removeItem('appStore')
        set({
          token: null,
          contracts: [],
          contractData: [],
          contractDataItem: {},
          expirationDate: 0,
          logoUrl: '',
          contractIsSelected: false,
          selectedContractId: '',
          contractSelectedLink: {},
          userName: '',
          brandName: '',
          brandPrimaryColor: '',
          customerId: ''
        })
      }
    }),
    {
      name: 'appStore',
      storage: createJSONStorage(() => sessionStorage)
    }
  )
)


export default useAppStore
